import { Box, Typography } from '@mui/material';
import { Link as LinkRouter, useLocation } from '@tanstack/react-router';

import { BreadCrumberContainer } from './style';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import React from 'react';

const segmentNames: Record<string, string> = {
  '': 'Jornal do Licitante',
  editais: 'Editais',
  contratacao: 'Contratação de Seguro',
};

const getBreadcrumbs = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean);
  const crumbs = [
    { name: segmentNames[''], path: '/' },
    ...segments.map((seg, idx) => {
      const path = '/' + segments.slice(0, idx + 1).join('/');
      return { name: segmentNames[seg] || seg, path };
    }),
  ];
  return crumbs;
};

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const breadcrumbs = getBreadcrumbs(location.pathname);

  return (
    <BreadCrumberContainer>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          py: '32px',
        }}
      >
        {breadcrumbs.map((crumb, idx) => {
          const isLast = idx === breadcrumbs.length - 1;
          return isLast ? (
            <Typography
              key={crumb.path}
              sx={{
                fontWeight: 400,
                color: '#808080',
                fontSize: { xs: '12px', md: '14px' },
                marginBottom: '4px',
              }}
            >
              {crumb.name}
            </Typography>
          ) : crumb.name === 'Editais' ? (
            <Box
              key={crumb.path}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Typography
                key={crumb.path}
                sx={{
                  fontWeight: 400,
                  color: '#808080',
                  fontSize: { xs: '12px', md: '14px' },
                  marginBottom: '4px',
                }}
              >
                {crumb.name}
              </Typography>
              <Typography
                sx={{
                  color: '#808080',
                }}
              >
                <ChevronRightIcon />
              </Typography>
            </Box>
          ) : (
            <Box
              key={crumb.path}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <LinkRouter
                className="link-router"
                to={crumb.path}
                onClick={() => {
                  if (crumb.path === '/') {
                    try {
                      localStorage.removeItem('asasAccessToken');
                      localStorage.removeItem('consultaCredito');
                    } catch (e) {
                      // ignore if localStorage not available
                    }
                  }
                }}
              >
                {crumb.name}
              </LinkRouter>
              <Typography
                sx={{
                  color: '#808080',
                }}
              >
                <ChevronRightIcon />
              </Typography>
            </Box>
          );
        })}
      </Box>
    </BreadCrumberContainer>
  );
};

export default Breadcrumb;
